import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import DrawerDialog, { DrawerDialogRef } from "../Base/DrawerDialog";
import orderManager from "../../manager/order";
import { toast } from "../../utils/toast";
import rm from "../../utils/rm";
import util, { getLeftTimeHHMMArray } from "../../utils/util";
import View from "../Base/View";
import { Button, Spin } from "antd";
import './index.scss'
import Image from "../Base/Image";

export interface PayOrderPanelRef {
    request: (payParams: any, callback: (state: string, data: any, tips: string) => void) => void
}

const PayOrderPanel = forwardRef((prop: {
    children: React.ReactNode
}, _ref) => {

    const [payOrderParams, setPayOrderParams] = useState<any>();
    const [paymentMethods, setPaymentMethods] = useState<{
        Icon: string,
        SystemName: string,
        FriendlyName: string,
    }[]>([]);
    const [currentSelectMethodIndex, setCurrentSelectMethodIndex] = useState<number>(0);
    const [timeLeft, setTimeLeft] = useState<string>();

    const callbackRef = useRef<((state: string, data: any, tips: string) => void)>();
    const modalRef = useRef<DrawerDialogRef>();
    const isOperating = useRef<boolean>(false)
    const countdowmTimer = useRef<number>(0)


    const countDown = useCallback((payOrderParams: any) => {
        if (payOrderParams) {
            const timeArray = util.getStartTimeLeftArray(payOrderParams.OrderInfo.CreatedOn, (payOrderParams.OrderInfo.AutoCloseUnpayedMinutes || 0) * 60 * 1000)
            const leftTimeStr = `支付剩余时间 ${timeArray[1]}:${timeArray[2]}:${timeArray[3]}`;
            setTimeLeft(leftTimeStr)
        }
    }, [])


    useImperativeHandle(_ref, () => ({
        request: (payParams: any, callback: (state: string, data: any, tips: string) => void) => {
            if(payParams.OrderInfo.PaymentMethodStatusId === 20){
                // 已支付
                callback("success", null, "支付完成")
            } else {
                callbackRef.current = callback;
                setPayOrderParams(Object.assign({}, payParams));
                countDown(payParams)
                countdowmTimer.current = setInterval(() => {
                    countDown(payParams)
                }, 1000) as any as number
            }
      
        }
    }))


    const pay = (method: string) => {
        if (!util.allowClick()) {
            return;
        }
        if (isOperating.current) {
            return;
        }
        rm.vibrate();
        orderManager._pay(
            {
                OrderId: payOrderParams.OrderId,
                PaymentMethodSystemName: method,
            },
            payOrderParams.OrderInfo,
            function (state: string, data: any, tips: string) {
                isOperating.current = false;
                modalRef.current?.close();
                if (callbackRef.current) {
                    callbackRef.current(state, data, tips);
                }
            }
        )
    }

    // 获取支付方式
    useEffect(() => {
        if (payOrderParams) {
            setPaymentMethods([])
            orderManager._getPayMethod(payOrderParams.OrderId, function (success: boolean, orderData: any, tips0: string) {
                if (success) {
                    if (orderData.data.Content.PaymentMethods.length > 1) {
                        setPaymentMethods(orderData.data.Content.PaymentMethods);
                        modalRef.current?.open();
                    } else if(orderData.data.Content.PaymentMethods.length === 1){
                        pay(orderData.data.Content.PaymentMethods[0].SystemName)
                    } else {
                        modalRef.current?.close();
                        if (callbackRef.current) {
                            callbackRef.current("error", null, "无可用支付方式");
                        }
                    }
                } else {
                    modalRef.current?.close()
                    if (callbackRef.current) {
                        callbackRef.current("error", null, "获取支付方式失败，请稍后再试");
                    }
                }
            })
        }
    }, [payOrderParams])



    return <>
        {prop.children}
        <DrawerDialog
            ref={modalRef}
            isModal={true}
            onVisibleChange={(open) => {
                if (!open) {
                    clearInterval(countdowmTimer.current)
                }
            }}
            direction={0}>
            {payOrderParams && <View className="pay-modal">
                <span className="pay-modal-title">请选择支付方式</span>
                <img className="pay-modal-close" onClick={()=>{
                       modalRef.current?.close()
                       if (callbackRef.current) {
                           callbackRef.current("cancel", null, "取消支付");
                       }
                }} src={require("../../images/cart-delete.png")} />
                <View className="pay-modal-order-info">
                    <span className="pay-modal-order-value">{payOrderParams.OrderInfo.OrderTotal}</span>
                    {timeLeft && <span className="pay-modal-order-time">{timeLeft}</span>}
                </View>
                <View className="pay-modal-methods">
                    {paymentMethods.length ?
                        <>{paymentMethods.map((i, index) => {
                            return <View className="pay-modal-method" key={i.SystemName}
                            onClick={()=>{
                                setCurrentSelectMethodIndex(index)
                            }}
                            >
                                <img className="icon" src={i.Icon} />
                                <span>{i.FriendlyName}</span>
                                <span className="flex-grow"></span>
                                <Image
                            className="check-icon"
                            src={require('../../images/cart-' +
                                (index === currentSelectMethodIndex ? 'select' : 'unselect') +
                                '.png')}
                        ></Image>
                            </View>
                        })}</>
                        : <Spin style={{
                            marginTop: 16,
                            marginBottom: 16
                        }}/>}
                </View>
                <span className="flex-grow"></span>
                <View className="pay-confirm-btn" onClick={() => {
                    pay(paymentMethods[currentSelectMethodIndex].SystemName)
                }}>确认支付</View>
            </View>
            }
        </DrawerDialog>
    </>
})

export default PayOrderPanel;